var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75736 10.2426C1.22636 9.71164 1.57855 8.59683 1.30828 7.9436C1.0281 7.26644 0 6.72144 0 5.99998C0 5.27853 1.0281 4.73354 1.30828 4.05639C1.57855 3.40317 1.22636 2.28836 1.75736 1.75736C2.28836 1.22636 3.40317 1.57855 4.0564 1.30828C4.73356 1.0281 5.27856 0 6.00002 0C6.72147 0 7.26646 1.0281 7.94361 1.30828C8.59683 1.57855 9.71164 1.22636 10.2426 1.75736C10.7736 2.28836 10.4214 3.40317 10.6917 4.0564C10.9719 4.73356 12 5.27856 12 6.00002C12 6.72147 10.9719 7.26646 10.6917 7.94361C10.4214 8.59683 10.7736 9.71164 10.2426 10.2426C9.71164 10.7736 8.59683 10.4214 7.9436 10.6917C7.26644 10.9719 6.72144 12 5.99998 12C5.27853 12 4.73354 10.9719 4.05639 10.6917C3.40317 10.4214 2.28836 10.7736 1.75736 10.2426Z",
    fill: "url(#paint0_linear_265_3631)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54567 4.61426L5.16104 7.84503L3.46875 6.22964",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_265_3631",
    x1: -3.45,
    y1: -5.25,
    x2: 20.0054,
    y2: -0.772154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0989439,
    stopColor: "#3DBDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829491,
    stopColor: "#067D71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.cff543c36bf551e83c719c4d314a4c24.svg";
export { ForwardRef as ReactComponent };